import { useContext } from "react";
import { DialogStateContext } from "../Providers/DialogContext";
import { DialogState } from "@/lib/Components/Dialog/Providers/DialogProvider";

export function useDialogState<TRecord = any>(): DialogState<TRecord> {
  return useContext(DialogStateContext);
}
